module.exports = __webpack_public_path__ + "media/images/clean_print-94eac16c4a17acc8714cb02ddc7d6d4e.png";